export default "__VITE_ASSET__BFFw_dCn__"